/* global grecaptcha */
/* eslint-disable no-unused-vars */

import { ENETUNREACH } from 'constants';

window.reCAPTCHA = window.reCAPTCHA || {
  render: function (formId) {
    //check whether the recaptcha container is on the page
    var recaptcha = $('.g-recaptcha', $('#' + formId));
    if (recaptcha.length === 0) return;
    //render the recaptcha in the correct form
    grecaptcha.render(recaptcha[0], {
      sitekey: recaptcha.data('sitekey')
    });
  }
};

$('body').on('click', '.js-form-validate input[type="submit"]', function (e) {
  var form = $(this).closest('form');
  if (form.find('.g-recaptcha').length != 0) {
    var captchaResponse = grecaptcha.getResponse();
    if (
      captchaResponse == '' &&
      !$('.recaptcha').hasClass('.recaptcha--invalid')
    ) {
      form.closest('form').find('.recaptcha').addClass('recaptcha--invalid');
      if (form.valid()) {
        e.preventDefault();
      }
    } else {
      form.closest('form').find('.recaptcha').removeClass('recaptcha--invalid');
    }
  }
});
